import {
  ICreateJournalEntryParams,
  ICreateJournalEntryRepository,
  ICreateJournalEntryRepositoryResponse,
} from "@/core/repositories/accounting";

export class CreateJournalEntryUseCase {
  constructor(private readonly repository: ICreateJournalEntryRepository) {}

  async execute(
    params: ICreateJournalEntryParams
  ): Promise<ICreateJournalEntryRepositoryResponse> {
    return this.repository.createJournalEntry(params);
  }
}

